module.exports = __webpack_public_path__ + "assets/img/202107-5W.48f9ef08.png";